/*
* @Author: zhangzhitao
* @Date: 2019-03-21 09:49:22
 * @Last Modified by: yuzhou.zhou
 * @Last Modified time: 2020-05-25 11:17:51
*/

<template>
  <el-dialog
    :title="$t('indexPage.about')"
    top="middle"
    class="m-about-dialog"
    :area="580"
    :visible.sync="visiable"
  >
    <neutral
      :aboutInfo="aboutInfo"
      :aboutBottomInfo="aboutBottomInfo"
      :baseUrl="baseUrl"
      :language="language"
      v-if="aboutInfo.neutral"
    ></neutral>
    <normal
      :aboutInfo="aboutInfo"
      :aboutBottomInfo="aboutBottomInfo"
      :language="language"
      v-else
    ></normal>
  </el-dialog>
</template>

<script>
import ApiConfig from 'api/config'
import normal from './normal'
import neutral from './neutral'
import API from 'api/api'
export default {
  name: 'portal-about',

  props: {
    aboutDialog: {
      type: Boolean,
      default: false
    },
    themeInfo: {
      type: Object,
      default: null
    },
    language: {
      type: String,
      default: 'zh_CN'
    }
  },

  data () {
    return {
      aboutInfo: {
        aboutIconInfo: {
          path: '',
          fileId: '-1'
        }
      },
      aboutBottomInfo: {
        license: '',
        licenseAgreement: '',
        privacyPolicy: ''
      }
    }
  },

  components: { normal, neutral },

  computed: {
    baseUrl () {
      if (ApiConfig) {
        return ApiConfig.baseUrl
      } else {
        return process.env.VUE_APP_BASEURL
      }
    },
    visiable: {
      get () {
        return this.aboutDialog
      },
      set (val) {
        this.$emit('changeVisiable', val)
      }
    }
  },

  mounted () {
    this.getAbout()
    // 获取底部三个证书地址
    API.common.getAbout().then(res => {
      this.aboutBottomInfo = res.data
    })
  },

  methods: {
    // 获取关于
    getAbout () {
      if (this.$route.query.tpw) {
        this.aboutInfo = this.$storage.get('theme-info')
      } else {
        API.theme.query().then(res => {
          this.aboutInfo = res.data
        }).catch(err => {
          this.$message.error(err.msg)
        })
      }
    }
  }
}

</script>

<style lang="less" scoped>
.m-about-dialog {
  /deep/ .el-dialog {
    .el-dialog__header {
      color: rgba(0, 0, 0, 0.9);
      border-bottom: 1px solid transparent;
      .el-dialog__title {
        color: rgba(0, 0, 0, 0.9);
      }
      .el-dialog__close {
        color: rgba(0, 0, 0, 0.9);
      }
    }
    .el-dialog__body {
      padding: 0;
      .el-dialog__body-wrapper {
        padding: 0;
      }
    }
  }
}
</style>
